const hexToRgb = (hex: string) => {
  let value = hex.replace("#", "");
  if (value.length === 3) {
    value = value.split("").map((char) => char + char).join("");
  }
  if (value.length !== 6) return undefined;
  return {
    r: Number.parseInt(value.slice(0, 2), 16),
    g: Number.parseInt(value.slice(2, 4), 16),
    b: Number.parseInt(value.slice(4, 6), 16),
  };
};

// true si el color hex (#RGB o #RRGGBB) es claro y necesita texto oscuro encima
export const isLightColor = (hex: string) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return false;
  return (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255 > 0.7;
};

export const getContrastTextColor = (hex: string) => (isLightColor(hex) ? "#111111" : "#FFFFFF");

// amount < 0 oscurece y > 0 aclara (mezcla con negro o blanco), entre -1 y 1
export const shadeColor = (hex: string, amount: number) => {
  const { r, g, b } = hexToRgb(hex) ?? { r: 0, g: 0, b: 0 };
  const target = amount < 0 ? 0 : 255;
  const mix = (channel: number) => Math.round(channel + (target - channel) * Math.abs(amount));
  return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
};

export const withAlpha = (hex: string, alpha: number) => {
  const { r, g, b } = hexToRgb(hex) ?? { r: 0, g: 0, b: 0 };
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
